import type { ApiPipeline } from "avvir";
import type { AvvirEvent } from "type_aliases";

export type CheckedPipeline = ApiPipeline & { downloadUrl?: string, downloadFileName?: string };

export type PipelineRunningProcessCheckedEvent = AvvirEvent<typeof PIPELINE_RUNNING_PROCESS_CHECKED, CheckedPipeline>

const pipelineRunningProcessChecked = (pipeline: CheckedPipeline): PipelineRunningProcessCheckedEvent => ({
  type: PIPELINE_RUNNING_PROCESS_CHECKED,
  payload: pipeline
});

export const PIPELINE_RUNNING_PROCESS_CHECKED = "pipeline_running_process_checked";

export default pipelineRunningProcessChecked;
